import { Navigate, useLocation } from 'react-router-dom';

// Backwards-compatibility redirects for the Process → Integration URL rename.
// Order matters: longer (more specific) prefixes must appear before shorter ones,
// so that nested paths are rewritten with their dedicated mapping rather than
// just the parent prefix.
const PATH_MAPPINGS: ReadonlyArray<readonly [string, string]> = [
  ['/processes/current_process_runs', '/integrations/current_runs'],
  ['/processes/history_process_runs', '/integrations/run_history'],
  ['/processes/process_runs', '/integrations/runs'],
  ['/processes/realtimestaging', '/integrations/realtime_staging'],
  ['/processes', '/integrations'],
  ['/process_errors', '/integration_errors'],
  ['/run_process', '/run_integration'],
];

function LegacyRouteRedirect() {
  const location = useLocation();
  const path = location.pathname;

  for (const [from, to] of PATH_MAPPINGS) {
    if (path === from || path.startsWith(from + '/')) {
      const rest = path.slice(from.length);
      return <Navigate to={to + rest + location.search + location.hash} replace />;
    }
  }

  return <Navigate to="/home" replace />;
}

// Mounted alongside the auto-generated `pagesRoutes`. Until the folder rename
// happens these routes are dormant — the more specific real page routes win
// in React Router v6's specificity-based matching. After the rename, these
// catch the legacy URLs (bookmarks, saved emails) and redirect transparently.
export const legacyRedirectRoutes = [
  { path: 'processes/*', element: <LegacyRouteRedirect /> },
  { path: 'process_errors/*', element: <LegacyRouteRedirect /> },
  { path: 'run_process/*', element: <LegacyRouteRedirect /> },
];
